module.exports = __webpack_public_path__ + "img/cta-mind-nl.7a80c439.png";